import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface OrderDetailsParams extends ApiParameter {
    pageNumber?: string;
    orderNumber?: string;
    currentDateTime?: string;
}

export interface OrderDetailsLineCollectionModel {
    productNumber: string;
    lineNumber: string;
    qtyShipped: string;
    properties: Properties;
}

export interface Properties {
    releasedQty: string;
    reservedQty: string;
    historyReleasedQty: string;
}

const url = "/api/v2/orderhistory/GetOrderLineDetails";

export const getOrderLineDetails = async (parameter: OrderDetailsParams) => {
    const response = await get<OrderDetailsLineCollectionModel[]>(url, parameter);
    return response;
};
